import { render } from "./ClaimNotes.vue?vue&type=template&id=56c8635e&bindings={}"
import script from "./ClaimNotes.vue?vue&type=script&lang=ts"
export * from "./ClaimNotes.vue?vue&type=script&lang=ts"
script.render = render

export default script